import { render, staticRenderFns } from "./VBtn.vue?vue&type=template&id=ebe0ceb0&"
import script from "./VBtn.vue?vue&type=script&lang=js&"
export * from "./VBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports